import { ActionButtons, Button, Heading, Modal, Para, Stack } from '@drycut/ui-components';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
};

export default function PreBookingCancelConfirm({
  open,
  onClose,
  onConfirm,
}: Props): React.ReactElement {
  return (
    <Modal open={open} onClose={onClose} title={<Heading variant="h2">Bist Du sicher?</Heading>}>
      <Stack className="gap-5 max-w-full md:max-w-lg items-center">
        <Para>
          Wenn Du Deine Reservierung stornierst, wird der Zeitslot wieder freigegeben und es mag
          sein, dass jemand anders ihn nimmt. Du erhältst bei der Stornierung einen Code, mit dem Du
          kostenlos eine neue Reservierung oder Buchung tätigen kannst. Möchtest Du die Reservierung
          stornieren?
        </Para>

        <ActionButtons className="mt-3">
          <Button onClick={onConfirm} fill="contained">
            Ja, Reservierung stornieren
          </Button>
          <Button onClick={onClose} fill="outlined">
            Nein, Reservierung behalten
          </Button>
        </ActionButtons>
      </Stack>
    </Modal>
  );
}
